import gql from 'graphql-tag'
import { PaymentMethodFieldsFragment } from './paymentMethod'

export const UPSERT_PAYMENT_METHOD_MUTATION = gql`
  mutation UpsertPaymentMethod($stripeToken: String, $publicToken: String, $metadata: Metadata) {
    upsertPaymentMethod(stripeToken: $stripeToken, publicToken: $publicToken, metadata: $metadata) {
      ...PaymentMethodFields
    }
  }

  ${PaymentMethodFieldsFragment}
`
